<template>
  <div>
    <page-header :title="$t('playerTag.management')">
      <li class="breadcrumb-item">
        <router-link :to="{name:'players.index'}">{{ $tc('player.name', 2) }}</router-link>
      </li>
      <li class="breadcrumb-item">{{ $t('playerTag.management') }}</li>
    </page-header>
    <page-content>
      <ntm-block :title="$t('playerTag.management')">
        <template slot="options">
          <button type="button" class="btn btn-sm btn-success" @click="openCreateModal">
            {{ $t('playerTag.create') }}
          </button>
        </template>
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-vcenter">
            <thead>
              <tr>
                <th>{{ $t('name') }}</th>
                <th>{{ $t('playerTag.color') }}</th>
                <th class="text-center">{{ $t('playerTag.public') }}</th>
                <th style="width: 120px;" class="text-center">{{ $tc('action.name', 2) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tag in tags" :key="tag.uuid">
                <td>
                  <span class="badge" :style="tagBadgeStyle(tag)">{{ tag.name }}</span>
                </td>
                <td>{{ tag.color || '—' }}</td>
                <td class="text-center">
                  <i v-if="tag.is_public" class="fa fa-check text-success"></i>
                  <i v-else class="fa fa-times text-muted"></i>
                </td>
                <td class="text-center">
                  <button class="btn btn-sm btn-info mr-1" @click="openEditModal(tag)">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button class="btn btn-sm btn-danger" @click="deleteTag(tag)">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="!tags.length">
                <td colspan="4" class="text-center text-muted">{{ $t('playerTag.empty') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ntm-block>
    </page-content>

    <modal name="player-tag-modal" height="auto" :minWidth="300" width="400">
      <div class="p-4" v-if="modalTag">
        <h5 class="mb-3">{{ modalTag.uuid ? $t('playerTag.edit') : $t('playerTag.create') }}</h5>
        <div class="form-group">
          <label>{{ $t('name') }}</label>
          <input class="form-control" v-model="modalTag.name" :placeholder="$t('name')" />
        </div>
        <div class="form-group">
          <label>{{ $t('playerTag.color') }}</label>
          <div class="d-flex align-items-center" style="gap: 8px;">
            <input type="color" class="form-control" style="width: 60px; padding: 2px;" v-model="colorInput" @input="modalTag.color = $event.target.value" />
            <input class="form-control" v-model="modalTag.color" :placeholder="$t('playerTag.colorHex')" @input="syncColor" />
          </div>
          <small class="text-muted">{{ $t('playerTag.colorHint') }}</small>
        </div>
        <div class="form-group">
          <div class="d-flex align-items-center" style="gap: 8px;">
            <input type="checkbox" id="tag-is-public" v-model="modalTag.is_public" />
            <label for="tag-is-public" class="mb-0">{{ $t('playerTag.public') }}</label>
          </div>
          <small class="text-muted">{{ $t('playerTag.publicHint') }}</small>
        </div>
        <div class="d-flex" style="gap: 8px;">
          <button class="btn btn-success" @click="saveTag" :disabled="!modalTag.name">{{ $t('save') }}</button>
          <button class="btn btn-secondary" @click="$modal.hide('player-tag-modal')">{{ $t('cancel') }}</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import PlayerTagService from '@/services/playerTag.service'

export default {
  data () {
    return {
      tags: [],
      modalTag: null,
      colorInput: '#3490dc'
    }
  },
  beforeRouteEnter (to, from, next) {
    PlayerTagService.index().then((response) => {
      next(vm => {
        vm.tags = response.data
      })
    })
  },
  methods: {
    tagBadgeStyle (tag) {
      if (!tag.color) return {}
      return {
        backgroundColor: tag.color,
        color: '#fff'
      }
    },
    openCreateModal () {
      this.modalTag = { name: '', color: null, is_public: false }
      this.colorInput = '#3490dc'
      this.$modal.show('player-tag-modal')
    },
    openEditModal (tag) {
      this.modalTag = { ...tag }
      this.colorInput = tag.color || '#3490dc'
      this.$modal.show('player-tag-modal')
    },
    syncColor (event) {
      const val = event.target.value
      if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
        this.colorInput = val
      }
    },
    saveTag () {
      const data = {
        name: this.modalTag.name,
        color: this.modalTag.color || null,
        is_public: !!this.modalTag.is_public
      }

      if (this.modalTag.uuid) {
        PlayerTagService.update(this.modalTag.uuid, data).then((res) => {
          const idx = this.tags.findIndex(t => t.uuid === this.modalTag.uuid)
          if (idx !== -1) this.$set(this.tags, idx, res.data)
          this.$modal.hide('player-tag-modal')
        })
      } else {
        PlayerTagService.store(data).then((res) => {
          this.tags.push(res.data)
          this.$modal.hide('player-tag-modal')
        })
      }
    },
    deleteTag (tag) {
      PlayerTagService.destroy(tag.uuid).then(() => {
        this.tags = this.tags.filter(t => t.uuid !== tag.uuid)
      })
    }
  }
}
</script>
